export const calcSalary = (bigItems, smallItems, payment) => {
	return (
		bigItems * payment.delivered_commision +
		smallItems * payment.additional_item_commision
	);
};
